import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { setForgotPasswordInitial } from '../_actions/forgotPassword.actions';
import { setLoginInitial } from '../_actions/login.actions';
import { setPaymentDetailsInitial } from '../_actions/paymentDetails.actions';
import { setRegisterInitial } from '../_actions/register.actions';
import { setUpdatePaymentInitial } from '../_actions/updatePayment.actions';
import { setUserAccountInitial } from '../_actions/userAccount.actions';

export function useSetInitial(): void {
    const dispatch = useDispatch();

    useEffect(() => {
        sessionStorage.removeItem('loggedIn');
        sessionStorage.removeItem('signupToken');

        dispatch(setLoginInitial());
        dispatch(setRegisterInitial());
        dispatch(setUserAccountInitial());
        dispatch(setForgotPasswordInitial());
        dispatch(setPaymentDetailsInitial());
        dispatch(setUpdatePaymentInitial());
    }, [dispatch]);
}
